import * as actionTypes from "./actionTypes";

const ChangeRequestsInitialState = {
  processing: {},
  loadingChangeRequests: true,
  changeRequests: null,
  filteredChangeRequests: null,
};

export const adminChangeRequestsReducer = (
  state = ChangeRequestsInitialState,
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_CHANGE_REQUESTS:
      return ChangeRequestsInitialState;
    case actionTypes.LOAD_CHANGE_REQUESTS:
      return {
        ...state,
        loadingChangeRequests: payload,
      };
    // case actionTypes.SET_PROCESSING:
    //   return { ...state, processing: true };
    // case actionTypes.STOP_PROCESSING:
    //   return { ...state, processing: false };

    case actionTypes.GET_CHANGE_REQUESTS:
      return {
        ...state,
        changeRequests: [...payload],
        filteredChangeRequests: [...payload],
      };

    case actionTypes.FILTER_CHANGE_REQUESTS:
      let result = [];

      if (payload.requestStatus === "ALL" && payload.licenseStatus === "ALL") {
        result = state.changeRequests;
      } else if (payload.requestStatus === "ALL") {
        result = state.changeRequests.filter(
          (request) => request.status === payload.licenseStatus
        );
      } else if (payload.licenseStatus === "ALL") {
        if (payload.requestStatus !== "NEW")
          result = state.changeRequests.filter(
            (request) => request.requestStatus !== "NEW"
          );
        else
          result = state.changeRequests.filter(
            (request) => request.requestStatus === payload.requestStatus
          );
      } else {
        result = state.changeRequests.filter(
          (request) =>
            request.status === payload.licenseStatus &&
            (payload.requestStatus === "NEW"
              ? request.requestStatus === payload.requestStatus
              : request.requestStatus !== "NEW")
        );
      }

      if (payload.searchTerm) {
        result = result.filter((request) =>
          request.bankName
            .toLowerCase()
            .includes(payload.searchTerm.toLowerCase())
        );
      }

      return {
        ...state,
        filteredChangeRequests: [...result],
      };

    case actionTypes.SET_DELETING:
      return {
        ...state,
        processing: {
          ...state.processing,
          [payload]: {
            deleting: true,
            accepting: false,
          },
        },
      };
    case actionTypes.DELETE_CHANGE_REQUEST:
      if (payload !== null) {
        // Remove request from the original and filtered change requests list
        const updatedChangeRequests = state.changeRequests.filter(
          (request) => request.id !== payload
        );

        const updatedFilteredChangeRequests =
          state.filteredChangeRequests.filter(
            (request) => request.id !== payload
          );

        return {
          ...state,
          processing: {
            ...state.processing,
            [payload]: {
              deleting: false,
              accepting: false,
            },
          },
          changeRequests: updatedChangeRequests,
          filteredChangeRequests: updatedFilteredChangeRequests,
        };
      } else {
        return {
          ...state,
          processing: {
            ...state.processing,
            [payload]: {
              deleting: false,
              accepting: false,
            },
          },
        };
      }

    case actionTypes.SET_ACCEPTING:
      return {
        ...state,
        processing: {
          ...state.processing,
          [payload]: { ...state.processing[payload], accepting: true },
        },
      };

    case actionTypes.ACCEPT_CHANGE_REQUEST:
      if (payload !== null) {
        const updatedRequests = state.changeRequests.map((request) => {
          if (request.id === action.payload) {
            return { ...request, requestStatus: "ACCEPTED" };
          }
          return request;
        });
        const filteredUpdatedRequests = state.filteredChangeRequests.map(
          (request) => {
            if (request.id === action.payload) {
              return { ...request, requestStatus: "ACCEPTED" };
            }
            return request;
          }
        );
        return {
          ...state,
          processing: {
            ...state.processing,
            [payload]: {
              deleting: false,
              accepting: false,
            },
          },
          changeRequests: updatedRequests,
          filteredChangeRequests: filteredUpdatedRequests,
        };
      } else {
        return {
          ...state,
          processing: {
            ...state.processing,
            [payload]: {
              deleting: false,
              accepting: false,
            },
          },
        };
      }

    default:
      return state;
  }
};
